if (!window.cardProductSwatches) {
  window.cardProductSwatches = true;

  const cards = new Map();

  const fetchCard = (url) => {
    if (!cards.has(url)) {
      const separator = url.includes('?') ? '&' : '?';
      cards.set(
        url,
        fetch(`${url}${separator}view=card`)
          .then((response) => response.text())
          .then((html) => new DOMParser().parseFromString(html, 'text/html').querySelector('.card-product'))
          .catch(() => {
            cards.delete(url);
            return null;
          })
      );
    }
    return cards.get(url);
  };

  const fadeInImages = (root) =>
    root.querySelectorAll?.('.card-product__image[loading="lazy"]:not(.card-product__image--hover)').forEach((image) => {
      if (image.complete) return;
      image.classList.add('is-pending');
      const reveal = () => image.classList.remove('is-pending');
      image.addEventListener('load', reveal, { once: true });
      image.addEventListener('error', reveal, { once: true });
    });

  fadeInImages(document);
  new MutationObserver((mutations) =>
    mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => node.nodeType === 1 && fadeInImages(node)))
  ).observe(document.body, { childList: true, subtree: true });

  const mainImage = (card) => card.querySelector('.card-product__image:not(.card-product__image--hover)');

  const preview = (swatch) => {
    const card = swatch.closest('.card-product');
    const image = mainImage(card);
    if (!image || !swatch.dataset.srcset) return;
    if (!image.dataset.originalSrcset) image.dataset.originalSrcset = image.srcset;
    image.srcset = swatch.dataset.srcset;
    card.classList.add('is-previewing');
    fetchCard(swatch.dataset.url);
  };

  const restore = (card) => {
    const image = mainImage(card);
    if (image?.dataset.originalSrcset) image.srcset = image.dataset.originalSrcset;
    card.classList.remove('is-previewing');
  };

  document.addEventListener('mouseover', (event) => {
    const swatch = event.target.closest?.('[data-card-swatch]');
    if (swatch) preview(swatch);
  });

  document.addEventListener('mouseout', (event) => {
    const list = event.target.closest?.('.card-product__swatch-list');
    if (list && !list.contains(event.relatedTarget)) restore(list.closest('.card-product'));
  });

  document.addEventListener('click', async (event) => {
    const swatch = event.target.closest('[data-card-swatch]');
    if (!swatch) return;
    event.preventDefault();
    const card = swatch.closest('.card-product');
    if (swatch.querySelector('.swatch--selected')) return;
    const next = await fetchCard(swatch.dataset.url);
    if (!card.isConnected) return;
    if (next) card.replaceWith(next.cloneNode(true));
    else restore(card);
  });
}
